/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import DisplayTextOnly from "cms/fields/layout/controls/display-text-only";
import { useCurrentDynamicField } from "cms/fields/hooks/use-current-dynamic-field";
import { FieldDisplayWrapper } from "cms/fields/layout/field-display-wrapper";
import { isArrayNotEmpty } from "utils/empty-exists";

const DecimalFieldDisplay = () => {
    
    const { field } = useCurrentDynamicField();
    const { values } = field || {};

    return (
        <FieldDisplayWrapper>
            {isArrayNotEmpty(values) &&
                values.map((item, index) => {
                    const { value, settings } = item || {};
                    const { style, format, options } = settings || {};
                    return (
                        <Fragment key={index}>
                            <DisplayTextOnly
                                value={value}
                                style={style}
                                format={format}
                                options={options}
                            />
                        </Fragment>
                    );
                })
            }
        </FieldDisplayWrapper>
    );
};
DecimalFieldDisplay.displayName = "DecimalFieldDisplay";
export { DecimalFieldDisplay };
